import { connectedStore } from '../../store';
import setHoveredElementAction from '../actions/set-hovered-element';

const setHoveredElement = (elementId) => {
  const store = connectedStore.get();
  store.dispatch(setHoveredElementAction(elementId));
};

export default setHoveredElement;
